import React from 'react';

export default class SessionModal extends React.Component {
    onClose = e => {
        this.props.onClose && this.props.onClose(e);
    };
    render() {
        if(!this.props.show){
            return null;
        }
        let readingList;
        if (this.props.readings) {
            readingList = this.props.readings.map((reading) => <li>{reading}</li>
        );
        }
        return (
            <div class="modal">
            <input
                type="image"
                className="modal_cross"
                src="/cross.png"
                onClick={e => {
                    this.onClose(e);
                }}
            />
            <div className="modal_content">
            <h1>{this.props.name}</h1>
            {this.props.description}
            <h2>Readings</h2>
            <ul>{readingList}</ul>
            </div>
            </div>
        );
    }
}

